<template>
	
	<div class="filter-bar">
		<div class="filter-bar__inner">
			<el-input v-model="filters.keywords" class="filter-bar__keywords" placeholder="Keywords" clearable></el-input>
			<el-button class="filter-bar__button" type="primary" @click="onClickAddButton" circle><ion-icon class="filter-bar__button-icon" name="add"></ion-icon></el-button>
			<el-popover
				class="filter-bar__button"
				width="320"
				trigger="click">
					<div>
						<h3 style="margin-top: 0;">Task Filters</h3>
						<el-form label-position="top">
							<el-form-item label="Sort">
								<el-select v-model="filters.sort" placeholder="Select types" style="width: 100%;">
									<el-option label="Pending > Finalised" value="pending_to_finalised"></el-option>
									<el-option label="Finalised > Pending" value="finalised_to_pending"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Types">
								<el-select v-model="filters.types" placeholder="Select types" style="width: 100%;" multiple collapse-tags>
									<el-option v-for="(value, i) in $store.state.ticketTypes" :label="value" :value="value" :key="i"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Statuses" style="margin-bottom: 0;">
								<el-select v-model="filters.statuses" placeholder="Select statuses" style="width: 100%;" multiple collapse-tags>
									<el-option v-for="(value, i) in $store.state.ticketStatuses" :label="value" :value="value" :key="i"></el-option>
								</el-select>
							</el-form-item>
							<!--<el-form-item label="Platforms" style="margin-bottom: 0;">
								<el-select v-model="filters.platforms" placeholder="Select platforms" style="width: 100%;" multiple collapse-tags>
									<el-option v-for="(value, i) in $store.state.platforms" :label="value" :value="value" :key="i"></el-option>
								</el-select>
							</el-form-item>-->
						</el-form>
					</div>
				<el-button class="filter-bar__button" slot="reference" circle><ion-icon class="filter-bar__button-icon" name="options"></ion-icon></el-button>
			</el-popover>
		</div>
	</div>
	
</template>

<script>
	
	import _ from "lodash";
	
	export default {
		
		methods: {
			
			triggerFilterStartEvent() {
				this.$emit("on-start-filters");
			},
			
			onClickAddButton() {
				this.$emit("on-click-add-button");
			},
			
		},
		
		watch: {
			filters: {
				deep: true,
				handler(oldValue, newValue) {
					this.triggerFilterStartEvent();
					this.triggerFilterChangeEvent();
				},
			}
		},
		
		created() {
			this.triggerFilterChangeEvent = _.debounce(() => {
				this.$emit("on-change-filters", this.filters);
			}, 1000);
		},
		
		data() {
			
			const statuses = [ ... this.$store.state.ticketStatuses ];
			
			//statuses.pop();
			
			return {
				filters: {
					project_id: this.$store.getters.project.id,
					keywords: "",
					sort: "pending_to_finalised",
					types: [ ... this.$store.state.ticketTypes ],
					statuses: statuses,
					//platforms: [ "Android", "iPhone", "iPad", "Web", "Desktop" ],
				},
			}
			
		}
		
	}
	
</script>

<style lang="scss">
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/TicketsListFilters.vue